<template>
  <div class="base-authentication page">
    <navigation :customClickEvent="true" @click="detention">完善资料，轻松提现</navigation>
    <section class="auth-banner">
      补充少量信息，匹配更优质资金…
    </section>

    <!-- 标题 -->
    <section class="title">
      <h1>补充资料</h1>
      <h2>请依照您的实际情况填写，确保信息真实可靠。</h2>
    </section>

    <!-- 表单 -->
    <form ref="form" class="form">
      <div v-for="col in allData" :key="col.colChineseName">
        <div class="card-title">
          <img :src="col.colIcon">
          <span>{{col.colChineseName}}</span>
        </div>
        <div class="card-panel">
          <div v-for="field in col.fieldDefs" :key="field.chineseName">
            <template v-if="isShow(field, col.fieldDefs)">
              <div class="form-item underline-un-focus"
                   :class="{'textarea': field.elementType === 'TEXTAREA'}"
                   v-if="!(['f13','f15'].includes(field.fieldId) && ['H','G','A'].includes(form['f5']) && field.elementType === 'TEXTAREA')"
              >
                <nd-choose
                  v-if="field.elementType === 'SELECT'"
                  :name="field.fieldId"
                  v-model="form[field.fieldId]"
                  :data="field.valueRange"
                  :valueKey="['key', 'value']"
                  :label="field.chineseName"
                  :text-align="field.style"
                  @change="handleChooseChange"
                >
                </nd-choose>
                <!-- <template
                  v-if="isNativeAndroid && field.nativeFunction === 'CONTACT'">
                    <div class="input-cover" @click="getNativeContact(col.colName)"></div>
                    <nd-input
                        v-if="field.elementType === 'INPUT'"
                        disabled
                        :name="field.fieldId"
                        v-model="form[field.fieldId]"
                        :label="field.chineseName"
                        :placeholder="field.placeholder"
                        :text-align="field.style"
                        :maxLength="String(field.maxLength)"
                        >
                    </nd-input>
                </template> -->
                <template>
                  <nd-input
                    v-if="field.elementType === 'INPUT'"
                    :name="field.fieldId"
                    v-model="form[field.fieldId]"
                    :label="field.chineseName"
                    :placeholder="field.placeholder"
                    :text-align="field.style"
                    :maxLength="String(field.maxLength)"
                  >
                  </nd-input>
                </template>
                <nd-address
                  v-if="field.elementType === 'AREA'"
                  :name="field.fieldId"
                  v-model="form[field.fieldId]"
                  :columns="3"
                  :mutilple="true"
                  inputStyle="width: 70%;margin-left: 30%"
                  :label="field.chineseName"
                  @open="openAddress"
                  @close="closeAddress"
                  @change="addressChange"
                  @scroll="addressScroll"
                >
                </nd-address>
                <nd-input
                  v-if="field.elementType === 'TEXTAREA'"
                  type="textarea"
                  :name="field.fieldId"
                  :autoSize="false"
                  :rows="1"
                  v-model="form[field.fieldId]"
                  :text-align="field.style"
                  :placeholder="field.placeholder"
                  @blur="addressBlur"
                  @focus="addressFocus"
                  @input="addressInput"
                  :maxLength="String(field.maxLength)"
                >
                </nd-input>
              </div>
            </template>
          </div>
        </div>
      </div>
    </form>

    <nd-button class="submit-btn" @click="submitBaseInfo">提交资料，轻松提现</nd-button>

    <!-- <div class="protocol-container">
            <p>点击「提交资料，立获额度」按钮即表示您已阅读并同意</p>
            <a href="javascript:;" @click="viewProtocol">《用户信息授权协议》</a>
        </div> -->

    <!-- 挽留弹窗 -->
    <nd-dialog v-model="detentionVisible" :footer="false" class="detention-dialog">
      <div class="detention-dialog-content">
        <div class="detention-title">
          <p>已为您匹配优质资金！</p>
          <p>真的要放弃吗？</p>
        </div>

        <ul class="giveup">
          <li
            v-for="(item, index) in giveUpReason"
            :key="index"
            @click="giveUp(index + 1)"
          >
            {{ item }}
          </li>
        </ul>

        <button class="continue" @click="continueApply">继续提现</button>
      </div>
    </nd-dialog>

    <!-- 活动弹窗 -->
    <nd-dialog
      v-model="activityVisible"
      :footer="false"
      closeBtn
      class="activity-dialog"
    >
      <div class="activity-content">
        <template v-if="currentActivity.couponDetailType === 'A'">
          <div class="slogan">
            <img src="./images/img_20yuan@2x.png" alt="">
          </div>

          <p class="text">
            最后一步，立马拿额度，可借额度高达<em>5万元</em>!
          </p>

          <div class="description">
            <div class="desc-image"></div>

            <p>
              授信未通过,即刻赔付现金红包！
              <em>最高赔100元</em>
            </p>
          </div>

          <nd-button class="continue-btn" @click="activityContinue">继续填写资料</nd-button>

          <div class="giveup-btn" @click="activityGiveUp">给钱也不要</div>
        </template>
        <template v-else>
          <div class="slogan">
            <img src="./images/img_100yuan@2x.png" alt="">
          </div>


          <p class="text">
            最后一步，立马拿额度，可借额度高达<em>5万元</em>!
          </p>

          <div class="description">
            <div class="desc-image"></div>

            <p>
              授信未通过,即刻赔付现金红包！
              <em>最高赔100元</em>
            </p>
          </div>

          <nd-button class="continue-btn" @click="activityContinue">继续填写资料</nd-button>

          <div class="giveup-btn" @click="activityGiveUp">给钱也不要</div>
        </template>
      </div>
    </nd-dialog>

    <!-- 活动弹窗 -->
    <nd-dialog
      v-model="activityTempleVisible"
      :footer="false"
      closeBtn
      class="activity-dialog"
    >
      <div class="activity-template-content" :style="{ 'background-image': `url(${ currentActivity.icon })` }">
        <div class="button-group">
          <nd-button class="continue-btn" @click="activityContinue">继续填写资料</nd-button>
          <div class="giveup-btn" @click="activityGiveUp">放弃免息返现</div>
        </div>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import validateNew from '@/components/nd-validate/validateNew'
import { judgeClientSystem, isTMDMiniprogram } from '@/assets/utils'
// import mockData from './data'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import { getKey } from '../../assets/utils'
import wx from 'weixin-webview-jssdk'

export default {
  name: 'base-authentication',

  mixins: [validateNew],

  data () {
    return {
      isAndroidP: judgeClientSystem() === 'Android',
      form: {},
      allData: [],
      rules: {},
      isDisabled: true,
      detentionVisible: false,
      activityVisible: false,

      // 切换网页发生次数
      blurEventOccurCount: 0,
      // 陀螺仪旋转发生次数
      deviceorientationEventOccurCount: 0,
      // 联系人电话校验不通过次数
      contactErrorEventOccurCount: 0,
      // 上次粘贴的内容
      clipboardText: '',
      agreeProtocol: true,
      pfrom: this.$route.query.pfrom,
      giveUpReason: [
        '不想拿钱了', '操作不便，不想继续', '手边资料不全，无法完成'
      ],
      deviceIp: '',
      currentOccupationData: {},
      winHeight: '',
      popupList: [],
      activityTempleVisible: false,
      currentActivity: {}
    }
  },
  computed: {
    ...mapState({
      dictionary: state => state.dictionary || {},
      caseList: state => state.caseList
    }),

    ...mapState('user', [
      'userInfo'
    ]),

    ...mapState('authentication', [
      'baseInfo'
    ]),
    isNativeAndroid () {
      return judgeClientSystem() === 'Android' && hasNativeMethod('requestContact')
    }
  },

  beforeRouteLeave (to, from, next) {
    // this.checkInputStep()
    this.cacheBaseInfo(this.form)
    next()
  },

  async created () {
    try {
      await Promise.all([this.getUserInfoX({ forceUpdate: true }), this.getUserInfo(), this.getCaseListX({ loanPlatform: 'TMD', step: 'INFO' })])
      this.$bus.$emit('ready')
      this.initDataEvent()
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },

  destroyed () {
    // 离开时移除监听事件
    this.destoryDataEvent()
  },

  methods: {
    ...mapActions([
      'fetchDictionaryX',
      'getCaseListX'
    ]),

    ...mapActions('authentication', [
      'saveBaseInfoX',
      'creditApplyX',
      'getBaseInfoX',
      'getQuickConfigX',
      'saveQuickConfigX'
    ]),

    ...mapMutations('authentication', [
      'cacheBaseInfo'
    ]),

    ...mapActions('user', [
      'getUserInfoX'
    ]),
    // 根据选择框判断是否显示输入框
    isShow (ele, list) {
      if (!ele.cascadeFields) return true
      /**
       * 当前field需要关联的field的id、value和show
       */
      const relationFieldId = ele.cascadeFields[0].fieldId
      const relationFieldValue = ele.cascadeFields[0].fieldValue
      const relationShow = ele.cascadeFields[0].isShow
      // 找到fieldId对应的field
      const relationField = list.find(data => {
        return data.fieldId === relationFieldId
      })
      // 查看field的值是否在relationFieldValue中
      const isIncludesValue = relationFieldValue.includes(this.form[relationField && relationField.fieldId])
      const isShow = relationShow ? isIncludesValue : !isIncludesValue
      /**
       * 由于错误提示的dom是在initValidateFormItem方法后生成的
       * 所以这里切换了dom的显示后，应该重新调用一下initValidateFormItem方法
       */
      if (isShow) {
        this.$nextTick(() => {
          const node = this.$refs.form.querySelector(`[name="${ele.fieldId}"]`)
          this.initValidateFormItem(node, ele.fieldId, this.rules)
        })
      }
      return isShow
    },
    handleChooseChange (text, fieldId) {
      if (text) this.removeValidateField(this.$refs.form, this.rules, fieldId)
    },
    // 检查用户填写到哪一步了
    checkInputStep () {
      let obj = {}
      Object.keys(this.form).map(key => {
        obj.key = this.rules[key]
      })
      const step1 = this.validateWithoutTip(obj)
      if (!step1) {
        this.$report({
          id: 10079,
          args: {
            step: 0
          }
        })
        return
      }
      const step2 = this.validateWithoutTip({
        relation1: this.rules.relation1,
        name1: this.rules.name1,
        mobile1: this.rules.mobile1
      })
      if (!step2) {
        this.$report({
          id: 10079,
          args: {
            step: 1
          }
        })
        return
      }
      const step3 = this.validateWithoutTip({
        relation2: this.rules.relation2,
        name2: this.rules.name2,
        mobile2: this.rules.mobile2
      })
      if (!step3) {
        this.$report({
          id: 10079,
          args: {
            step: 2
          }
        })
        return
      }
      return this.$report({
        id: 10079,
        args: {
          step: 3
        }
      })
    },

    // 获取字典
    initDictionary () {
      this.fetchDictionaryX()
    },

    // 获取用户信息
    async getUserInfo () {
      const quickConfig = await this.getQuickConfigX({
        funcName: 'QUICK_CONFIG',
        productCode: 'TMDP'
      })

      // this.form = {
      //     f10: 'T',
      //     f11: '姓名2',
      //     f12: '138123',
      //     f13: '水岸东方公司',
      //     f2: 'C',
      //     f3: 'S',
      //     f4: 'D',
      //     f5: 'B',
      //     f6: '重庆市 重庆市 北碚区 500000 500100 500109',
      //     f7: 'B',
      //     f8: '姓名1',
      //     f9: '17623333',
      //     f14: '测试详细地址'
      // }



      let arr = quickConfig.data.defCollections
      this.allData = arr
      this.allData.forEach(item => {
        item.fieldDefs.map(ele => {
          if (ele.fieldName === 'occupations') {
            ele.valueRange = ele.valueRange.filter(i => {
              return !['H', 'G', 'A'].includes(i.key)
            })
          }
          // 设置回显的值
          // this.$set(this.form, ele.fieldName, ele.value)
          // 设置校验规则
          const rules = ele.checkDefinations.map(rule => {
            const newRule = {
              message: rule.toast
            }
            if (rule.require) {
              newRule.require = true
            } else {
              if (rule.checkType === 'REG') {
                newRule.regular = new RegExp(rule.checkRule)
              }
            }
            return newRule
          })
          this.$set(this.rules, ele.fieldId, rules)
        })
      })
      // 因为配置从接口获取，这里必定会比mounted晚，所以在rules配置完成后执行一下validator方法
      this.$nextTick(() => {
        this.validator(this.$refs.form, this.rules)
      })
    },

    async getNativeContact (colName) {
      if (this.isAndroidP && hasNativeMethod('requestContact')) {
        const res = await jsBridge('requestContact', {
          colName
        })
        if (res.code === 'OK') {
          const curCol = this.allData.find(col => {
            return col.colName === colName
          })
          Object.keys(res.data).forEach(key => {
            curCol.fieldDefs.forEach(field => {
              if (field.fieldName === key) {
                this.removeValidateField(this.$refs.form, this.rules, field.fieldId)
                this.form = {
                  ...this.form,
                  [field.fieldId]: res.data[key].replace(/\s+/g, '')
                }
              }
            })
          })
        }
      }
    },

    // 提交资料
    async submitBaseInfo () {
      const valid = this.validate(this.$refs.form, this.rules)
      let f9, f12
      if (!valid) return

      const params = {
        fieldSaveBeans: {}
      }

      this.allData.forEach(col => {
        const fieldArr = []
        col.fieldDefs.forEach(field => {
          if (this.isShow(field, col.fieldDefs)) {
            if (field.fieldId === 'f9') {
              f9 = this.form[field.fieldId]
            }
            if (field.fieldId === 'f12') {
              f12 = this.form[field.fieldId]
            }
            fieldArr.push({
              fieldId: field.fieldId,
              value: this.form[field.fieldId]
            })
          }
        })
        params.fieldSaveBeans[col.colName] = fieldArr
      })
      const mobile = getKey('userInfo', 'mobile') || ''
      if (f9 && f12) {
        if (f9 === f12) {
          this.$message('联系人重复，请重新输入')
          return
        }
        if ([f9, f12].includes(mobile)) {
          this.$message('本人不能为联系人，请重新输入')
          return
        }
      }

      params.funcName = 'QUICK_CONFIG'
      params.productCode = 'TMDP'
      let { notify = '', fundCode = '', passCardProcess, riskTagProcess } = this.$route.query // notify 为F 为空则不发短信通知 为T则发短信通知 为T，F的时候跳转预览界面, W 跳安卓原生
      if (getKey('channel') === 'API-XHQB') {
        params.notify = true
      }

      // 缓存用户基本信息
      this.cacheBaseInfo(this.form)

      const response = await this.saveQuickConfigX(params)

      if (response.success) {
        // 全部完成 -> 去授信
        this.$statistics('BASE_SUC')
        // this.$router.push(`/withdraw/preview?fundCode=${this.fundCode}`)
        if (hasNativeMethod('thirdPartyToNavigate') && judgeClientSystem() !== 'IOS' && notify === 'W') {
          jsBridge('thirdPartyToNavigate')
          return
        } 
        if (notify) {
          const params = {
            fundCode: fundCode
          }
          if (passCardProcess) {
            params.passCardProcess = 'Y'
          }
          if (riskTagProcess) {
            params.riskTagProcess = riskTagProcess
          }
          if (isTMDMiniprogram()) {
            wx.miniProgram.postMessage({
              data: { eventType: 'WITHDRAW_PREVIEW', value: JSON.stringify(params) }
            })
            wx.miniProgram.navigateBack()
          } else {
            this.$router.push({
              path: `/withdraw/preview`,
              query: params
            })
          }
        } else {
          this.$router.replace(`/middle/limit`)
        }
      } else {
        this.$statistics('BASE_FAIL', {
          comment: response.msg
        })
        this.$message(response.msg)
      }
    },

    initDataEvent () {
      window.addEventListener('blur', this.blurEvent)
      window.addEventListener('deviceorientation', this.orientationEvent)
      window.addEventListener('paste', this.pasteEvent)
      const system = judgeClientSystem()
      if (system === 'IOS') {
        document.body.addEventListener('focusin', this.iosFocusIn)
        document.body.addEventListener('focusout', this.iosFocusOut)
      } else {
        this.winHeight = document.documentElement.clientHeight
        window.addEventListener('resize', this.androidWindowResize)
      }
    },

    destoryDataEvent () {
      window.removeEventListener('blur', this.blurEvent)
      window.removeEventListener('deviceorientation', this.orientationEvent)
      window.removeEventListener('paste', this.pasteEvent)
      const system = judgeClientSystem()
      if (system === 'IOS') {
        document.body.removeEventListener('focusin', this.iosFocusIn)
        document.body.removeEventListener('focusout', this.iosFocusOut)
      } else {
        window.removeEventListener('resize', this.androidWindowResize)
      }
    },

    blurEvent () {
      this.blurEventOccurCount++
    },

    pasteEvent (event) {
      try {
        event.clipboardData.items[0].getAsString(str => {
          this.clipboardText = str
        })
      } catch (error) {
      }
    },

    // 查看协议
    viewProtocol () {
      this.$router.push({
        path: '/protocol/authorization',
        query: {
          busiType: 'CREDIT'
        }
      })
    },

    // 放弃激活额度
    giveUp (index) {
      if (this.isAndroidP && hasNativeMethod('exit')) {
        return jsBridge('exit')
      }
      if (this.pfrom === 'landing') {
        // this.$router.push('/landing/index')
        this.$router.back()
      } else {
        this.detentionVisible = false
        this.$nextTick(() => {
          this.$router.push('/')
        })
      }
    },

    // 继续激活额度
    continueApply () {
      this.detentionVisible = false
    },

    // 用户挽留政策
    detention () {
      // 基本信息界面 弹出二次确认框
      this.popupList = this.caseList.filter(item => item.showType === 'POPUP' && item.showAction === 'EXIT' && item.step === 'INFO').sort((a, b) => b.sort - a.sort)
      this.detentionStep()
    },

    // 开始判断
    detentionStep () {
      const { limitStatus } = getKey('userInfo')
      if (this.popupList.length > 0) {
        this.currentActivity = this.popupList.shift()
        if (this.currentActivity.activeType !== 'PAY_IF_REFUSE_NEW') { // 不是拒就陪
          if (this.currentActivity.activeType === 'PERSON_REPEAT_LOAN' || limitStatus === 'E') { // 覆贷
            this.detentionVisible = true
          } else {
            this.activityTempleVisible = true
          }
        } else {
          this.activityVisible = true
        }
      } else {
        this.detentionVisible = true
      }
    },

    // 活动点击继续完成
    activityContinue () {
      this.$report({
        id: 10122,
        args: {
          position: 'page_auth_baseinfo',
          target: 1,
          status: this.currentActivity.activeType
        }
      })
      if (this.currentActivity.activeType !== 'PAY_IF_REFUSE_NEW') {
        this.activityTempleVisible = false
      } else {
        this.activityVisible = false
      }
    },

    // 活动点击放弃
    activityGiveUp () {
      if (this.currentActivity.activeType !== 'PAY_IF_REFUSE_NEW') {
        this.activityTempleVisible = false
      } else {
        this.activityVisible = false
      }
      this.detentionStep()
    },

    occupationChange (data) {
      this.currentOccupationData = data
    },

    occupationScroll () {
    },

    maritalChange (data) {
    },

    maritalScroll () {
    },

    addressChange (data, fieldId) {
      if (data) this.removeValidateField(this.$refs.form, this.rules, fieldId)
    },

    addressScroll () {
    },

    // IOS键盘弹出时会触发focusin事件
    iosFocusIn () {
    },

    // IOS键盘收起时会触发focusout事件
    iosFocusOut () {
    },

    // 安卓手机键盘弹出和收起时多半都会触发resize事件
    androidWindowResize () {
      var thisHeight = document.documentElement.clientHeight
      if (this.winHeight - thisHeight > 100) {
        this.winHeight = thisHeight
      } else if (this.winHeight - thisHeight < -100) {
        this.winHeight = thisHeight
      }
    },

    // 现居住地获得焦点
    addressFocus () {
    },

    // 现居住地失去焦点
    addressBlur () {
    },

    // 现居住地内容发生变化
    addressInput (target) {
    },

    // 单位名称获取焦点
    corpNameFocus () {
    },

    // 单位名称失去焦点
    corpNameBlur () {
    },

    // 单位名称内容发生变化
    corpNameInput (target) {
    },

    // 单位电话获得焦点
    corpPhoneFocus () {
    },

    // 单位电话失去焦点
    corpPhoneBlur () {
    },

    // 单位电话内容发生变化
    corpPhoneInput (target) {
    },

    // 单位地址获得焦点
    corpAddressFocus () {
    },

    // 单位地址失去焦点
    corpAddressBlur () {
    },

    // 单位地址内容发生变化
    corpAddressInput (target) {
    },

    // 选择职业 - 下拉框弹出
    openOccupation () {
    },

    // 选择职业 - 下拉框收起
    closeOccupation () {
    },

    // 选择婚姻状况-下拉框弹出
    openMarital () {
    },

    // 选择婚姻状况-下拉框收起
    closeMarital () {
    },

    // 选择现居住地-下拉框弹出
    openAddress () {
    },

    // 选择现居住地-下拉框收起
    closeAddress () {
    }
  },

  watch: {
    detentionVisible (value) {
      this.$report({
        id: 10082,
        args: {
          visible: value ? 1 : 0
        }
      })
    },

    activityVisible (value) {
      this.$report({
        id: 10121,
        args: {
          position: 'page_auth_baseinfo',
          visible: value ? 1 : 0,
          status: this.currentActivity.activeType
        }
      })
    },

    activityTempleVisible (value) {
      this.$report({
        id: 10121,
        args: {
          position: 'page_auth_identity',
          visible: value ? 1 : 0,
          status: this.currentActivity.activeType
        }
      })
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

    .page.base-authentication {
        background-color: #F7F7F7;
        padding-bottom: 63px;
        .auth-banner{
            width: 100%;
            height: 110px;
            background: url(./images/img_a@3x.png) center no-repeat;
            background-size: 100%;
            color: #FFFFFF;
            font-size: 28px;
            text-align: center;
            line-height: 110px;
        }

        .title {
            padding: 32px 40px;
            margin-top: 20px;
            background-color: #fff;

            h1 {
                font-size: 46px;
                font-family: PingFangSC-Medium,PingFang SC;
                font-weight: 500;
                height: 65px;
                line-height: 65px;
                color: @fc1;
                position: relative;

                img {
                    width: 56px;
                    position: absolute;
                    bottom: 7px;
                }

                span {
                    margin-left: 76px;
                }
            }

            h2 {
                margin-top: 17px;
                font-size: 28px;
                line-height: 40px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: @fc3;
            }
        }

        .form {
            .card-title {
                height: 45px;
                line-height: 45px;
                margin: 75px 40px 23px;
                font-size: 32px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: @fc3;
                position: relative;

                img {
                    width: 44px;
                    height: 44px;
                    position: absolute;
                    left: 0;
                }

                span {
                    margin-left: 56px;
                }
            }

            .card-panel {
                background-color: white;

                .form-item {
                    height: 110px;
                    line-height: 110px;
                    padding: 0 40px;
                    margin-top: 0;
                    // .form-tip{
                    //     top: 65%;
                    // }
                    .input-cover{
                        position: absolute;
                        left: 40px;
                        right: 40px;
                        z-index: 1;
                        height: 100%;
                    }

                    &.textarea {
                        height: 80px;
                        .nd-input {
                            margin-top: 40px;
                            line-height: 1.4em;
                        }
                    }

                    .nd-select,.nd-input,.nd-choose,.nd-address {
                        label {
                            font-size: 30px;
                            font-family: PingFangSC-Regular,PingFang SC;
                            font-weight: 400;
                        }

                        input {
                            font-size: 30px;
                        }

                        textarea {
                            font-size: 30px;
                        }
                    }

                    .nd-input {
                        .nd-input-inner {
                            line-height: 1.4em;
                        }
                    }
                }
            }
        }

        .submit-btn {
            margin: 0 auto;
            margin-top: 80px;
        }

        .protocol-container {
            color: @fc3;
            font-size: 24px;
            font-family: PingFangSC-Regular,PingFang SC;
            font-weight: 400;
            line-height: 33px;
            text-align: center;
            margin-top: 30px;

            a {
                margin-top: 4px;
                color: #8EB2D8;
            }
        }

        .detention-dialog {
            .detention-title {
                margin: 0 58px;
                text-align: center;
                font-size: 36px;
                line-height: 50px;
                font-family: PingFangSC-Medium,PingFang SC;
                font-weight: 500;
                padding-bottom: 34px;
                border-bottom: 1px solid #EEEEEE;
            }

            .giveup {
                li {
                    height: 110px;
                    line-height: 110px;
                    text-align: center;
                    font-size: 30px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    color: @fc3;
                    border-bottom: 1px solid #EEEEEE;
                }
            }

            .continue {
                border: 0px solid transparent;
                height: 160px;
                line-height: 160px;
                text-align: center;
                font-size: 36px;
                font-family: PingFangSC-Medium,PingFang SC;
                font-weight: 500;
                color: @theme;
                width: 100%;
                -webkit-appearance: none;
                outline: none;
                background-color: #FFFFFF;
            }
        }

        .activity-dialog {
          .default-content {
            padding-top: 0;
          }
            .activity-content {
                padding: 0 60px;
                padding-top: 42px;
                padding-bottom: 42px;

                .slogan {
                    height: 42px;

                    img {
                        height: 100%;
                        width: unset;
                    }
                }

                .text {
                    font-size: 32px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    color: @fc1;
                    font-weight: 400;
                    margin-top: 43px;


                }

                p {
                    em {
                        font-style: normal;
                        color: @theme;
                    }
                }

                .description {
                    width: 500px;
                    height: 130px;
                    background-color: #FFF0F0;
                    padding: 29px 0;
                    border-radius: 16px;
                    margin-top: 100px;
                    padding-left: 141px;
                    position: relative;

                    .desc-image {
                        height: 160px;
                        width: 116px;
                        background-image: url(./images/img_ren@2x.png);
                        position: absolute;
                        left: 30px;
                        bottom: 0px;
                        background-size: cover;
                    }

                    p {
                        font-size: 24px;
                        font-family: PingFangSC-Regular,PingFang SC;
                        font-weight: 400;
                        color: @fc2;
                        line-height: 1.6em;
                    }
                }

                .continue-btn {
                    width: 440px;
                    margin: 0 auto;
                    height: 80px;
                    line-height: 80px;
                    font-size: 36px;
                    font-weight: 600;
                    margin-top: 70px;
                }

                .giveup-btn {
                    height: 40px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    line-height: 40px;
                    color: @fc3;
                    text-decoration: underline;
                    text-align: center;
                    margin-top: 22px;
                }
            }

            .activity-template-content {
                width: 620px;
                height: 750px;
                background-size: contain;
                position: relative;

                .button-group {
                    position: absolute;
                    bottom: 48px;
                    left: 50%;
                    transform: translateX(-50%);

                    .continue-btn {
                        width: 440px;
                        margin: 0 auto;
                        height: 80px;
                        line-height: 80px;
                        font-size: 36px;
                        font-weight: 600;
                        margin-top: 70px;
                    }

                    .giveup-btn {
                        height: 40px;
                        font-size: 28px;
                        font-family: PingFangSC-Regular,PingFang SC;
                        font-weight: 400;
                        line-height: 40px;
                        color: @fc3;
                        text-decoration: underline;
                        text-align: center;
                        margin-top: 22px;
                    }
                }
            }
        }
    }
</style>


